module.exports = __webpack_public_path__ + "img/tubulacao.37f302e5.svg";